import moment from "moment";
import {useMemo} from "react";
import {useSelector} from "react-redux";
import {makeGetTechnologyGroupSettings} from "../selectors/settingsSelector";
import {
    formatTechnoGroupName,
    getLastTechnologyGroupNames,
    getTechnologyGroupByTime,
} from "../utils/TechnologyGroupUtils";

export default function useFilterValueGroups(filterType, filterValue) {
    const getTechnologyGroupSettings = useMemo(
        () => makeGetTechnologyGroupSettings(),
        []
    );
    const technologyGroupSettings = useSelector(getTechnologyGroupSettings);

    const groups = useMemo(() => {
        if (filterType === "technologyGroup") {
            let groups = [];
            switch (filterValue.unit) {
                case "lastXClosed":
                    groups = getLastTechnologyGroupNames(
                        filterValue.group,
                        20,
                        technologyGroupSettings
                    );
                    break;
                case "lastGroups":
                    groups = getLastTechnologyGroupNames(
                        filterValue.group,
                        0,
                        technologyGroupSettings
                    );
                    break;
                case "groupPicker":
                    groups = filterValue.group;
                    break;
                case "group":
                    groups = [filterValue.group];
                    break;
                case "week":
                    const {group} = filterValue;
                    const time = moment.utc().subtract(group, "weeks");
                    const technologyGroup = getTechnologyGroupByTime(
                        time,
                        technologyGroupSettings.start,
                        technologyGroupSettings.weeks,
                        technologyGroupSettings.method,
                        technologyGroupSettings.years
                    );
                    if (technologyGroup)
                        groups = [formatTechnoGroupName(technologyGroup, true)];
                    break;
                default:
                    console.warn("Nieznane grupowanie");
            }
            return groups;
        }
        if (filterType === "cycle") {
            let groups = [];
            switch (filterValue.unit) {
                case "cycle":
                    groups = [filterValue.value];
                    break;
                case "cycleRange":
                    groups = [
                        `${filterValue.value[0]}-${filterValue.value[1]}`,
                    ];
                    break;
                case "cycleGrouped":
                    groups = filterValue.value.map(
                        (row) => `${row[0]}-${row[1]}`
                    );
                    break;
                default:
                    console.warn("Nieznane grupowanie");
            }
            return groups;
        }
        switch (filterValue.unit) {
            case "finisherGroup":
                return [filterValue.group];
            case "groupPicker":
                return filterValue.group;
            case "lastInsertedGroups":
            case "lastClosedGroups":
                return filterValue.groups;
            default:
                break;
        }
        return [];
    }, [filterType, filterValue, technologyGroupSettings]);

    return groups;
}
